// Components
require('./header/js/header');
require('./slider/js/slider');